import React, { useState, useMemo } from "react";

// @material-ui/core components
import { makeStyles } from "tss-react/mui";
import { FormControl } from "@mui/material";

// core components
import Button from "../CustomButtons/Button.js";

import ForumsBlockerModal from "../ForumsBlockerModal/ForumsBlockerModal";
import ForumsLexicalEditor from "../ForumsLexical/ForumsLexicalEditor.js";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";
import {useTopicContext} from "../../contexts/topic";
import {useCommentContext} from "../../contexts/comment";
import {useForumsEditCommentRequest, useForumsEditTopicRequest} from "../../request/api";

const useStyles = makeStyles()(styles);

export default function ForumsTopicEditReply(props) {
    const [errors, setErrors] = React.useState({});
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [isBlocked, setIsBlocked] = React.useState(false);
    const { classes, cx } = useStyles();
    const onClose = props.onClose;
    const setEdited = props.setEdited;

    const [newPost, setNewPost] = useState(props.topic.content);
    const [successModalOpen, setSuccessModalOpen] = useState(false);

    const topicContext = useTopicContext();
    const commentContext = useCommentContext();

    const reloadComment = commentContext?.reloadComments ?? topicContext?.reloadTopic;

    const {
        isMutating: isCommentPost,
        trigger: editComment,
        error: editCommentError,
    } = useForumsEditCommentRequest(
      {
          commentId: props.topic.commentId,
          topicId: props.topic.topicId
      },
      undefined,
      {
          withCredentials: true,
      }
    );

    const handleSubmit = async (event) => {
        event.preventDefault();
        setEdited(true)
        setIsSubmitting(true);
        setSuccessModalOpen(false);
        setErrors({});

        try {
            const res = await editComment({
                body: {
                    content: newPost,
                },
            }).then((res) => res.data);

            window.gtag && window.gtag("event", "forum_comment_edit_submit");

            if (res?.success) {
                if (res?.status === "unapproved") {
                    setIsBlocked(true);
                    setIsSubmitting(false);
                }
                else {
                    await reloadComment();
                    onClose();
                    setSuccessModalOpen(true);
                }
            }
        } catch (e) {
            console.error(e);
            setErrors(e.response?.data?.errors);
        } finally {
            setIsSubmitting(false);
            reloadComment();
        }
    }

    return (
        <>
      <form onSubmit={handleSubmit}>
            <FormControl fullWidth>
                <ForumsLexicalEditor newPost={newPost} setNewPost={setNewPost} />
                <div className={classes.editorButtons}>
                <Button type="submit" className={cx(classes.darkButton + " " + classes.mediumButton)}>
                    {isSubmitting ? <>
                        Submitting
                    </> : <>
                        Submit
                    </>}
                </Button>
                <Button className={classes.cancelButton} onClick={() => onClose()}>Cancel</Button>
                </div>
            </FormControl>
      </form>
      {isBlocked &&
        <ForumsBlockerModal type="language" open={isBlocked} onClose={handleClose} />
      }
      </>
    )
}

